<template>
  <button
    :disabled="disabled"
    class="slide-control button button-compact"
    @click="onButtonClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'SlideshowControl',
  props: {
    slideshow: {
      type: String,
      required: true,
    },
    direction: {
      type: String,
      default: 'next',
    },
    loop: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      disabled: true,
    }
  },

  mounted () {
    this.disabled = !this.loop

    setTimeout(() => {
      this.$parent.$children.map((child) => {
        if (child.getName && child.getName() === 'Slideshow' && child.refId === this.slideshow) {
          this.$slideshow = child
          this.$slideshow.addCallback(this.init)
        }
      })
    }, 100)
  },

  methods: {
    init () {
      if (this.$slideshow.$flickity) {
        this.isDisabled()
        this.registerEvents()
      }
    },

    registerEvents () {
      this.$slideshow.$flickity.on('select', () => {
        this.disabled = this.isDisabled()
      })
    },

    isDisabled () {
      let isDisabled = true

      if (this.loop) {
        return false
      }

      if (this.direction === 'previous') {
        isDisabled = this.$slideshow.$flickity.selectedIndex <= 0
      } else if (this.direction === 'next') {
        isDisabled = (this.$slideshow.$flickity.slides.length - 2) === this.$slideshow.$flickity.selectedIndex
      }

      return isDisabled
    },

    onButtonClick () {
      if (this.direction === 'next') {
        this.$slideshow.next()
      } else if (this.direction === 'previous') {
        this.$slideshow.previous()
      }
    },
  },
}
</script>
